import { Box, Flex, Heading, useToast, VStack } from "@chakra-ui/react";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CustomButton, CustomFormControl, CustomPasswordInput, Layout } from "@lubbezposrednio-frontend/commons";
import { PASSWORD_TOOLTIP, bindProperty, bindToCommand, authorization } from "@lubbezposrednio-frontend/core";

interface ResetPasswordViewProps {}

const ResetPasswordView: React.FC<ResetPasswordViewProps> = observer(({}) => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const toast = useToast();
  useEffect(() => {
    document.title = "Reset hasła";
  }, []);

  const inputIds = {
    password: "password",
    confirmPassword: "confirm-password"
  };

  return (
    <Layout>
      <Flex flex={1} justify="center" align="center" px="20px" py={{ base: "40px", md: "64px" }} minH="60vh">
        <Box bg="white" borderRadius="24px" border="1px solid rgba(67,0,152,0.08)" boxShadow="0 20px 50px rgba(67,0,152,0.1)" p={{ base: "32px 26px", md: "40px" }} maxW="440px" w="100%">
          <Heading fontSize={{ base: "24px", md: "27px" }} fontWeight="800" color="primary" mb="6px">
            Ustaw nowe hasło
          </Heading>

          <VStack align="stretch" spacing="16px" mt="22px">
            <CustomFormControl
              id={inputIds.password}
              isInvalid={authorization.getIsTouched(inputIds.password) && !authorization.isPasswordCorrect}
              errorMessage={PASSWORD_TOOLTIP}
              tooltipMessage={PASSWORD_TOOLTIP}
              onFocus={() => authorization.setIsTouched(inputIds.password)}
              w="100%"
              labelTitle="Hasło"
            >
              <CustomPasswordInput {...bindProperty(authorization, "password")} />
            </CustomFormControl>

            <CustomFormControl
              id={inputIds.confirmPassword}
              isInvalid={authorization.getIsTouched(inputIds.confirmPassword) && !authorization.arePasswordsTheSame}
              errorMessage="Hasła nie są identyczne"
              onFocus={() => authorization.setIsTouched(inputIds.confirmPassword)}
              w="100%"
              labelTitle="Powtórz hasło"
            >
              <CustomPasswordInput {...bindProperty(authorization, "confirmPassword")} />
            </CustomFormControl>

            <CustomButton
              text="Ustaw hasło"
              {...bindToCommand(authorization.resetPassword(toast, params.get("token") ?? "", navigate))}
              backgroundColor="primary"
              w="100%"
              mt="6px"
            />
          </VStack>
        </Box>
      </Flex>
    </Layout>
  );
});

export default ResetPasswordView;
